import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from '@/app';
import PiwikPro from '@piwikpro/react-piwik-pro';
import { setPiwikCompliance, setPiwikInitialCompliance } from './utils/piwik-consent-helper';

interface IEnvironmentDetails {
    id: string;
    url: string;
}

interface ISiteConfig {
    prod: IEnvironmentDetails;
    qa: IEnvironmentDetails;
}

const CONTAINER_CONFIG: Record<string, ISiteConfig> = {
    'uwhealthtransplant': {
        prod: {
            id: 'e5502698-db7c-42c8-ba51-b42434a589c6',
            url: 'https://uwhealth.containers.piwik.pro/'
        },
        qa: {
            id: 'e5502698-db7c-42c8-ba51-b42434a589c6',
            url: 'https://uwhealth.containers.piwik.pro/' // Or use the same URL if sharing accounts
        }
    },
    'nkr': {
        prod: {
            id: 'd94e6a0d-6a97-4ace-8725-433bd5e698e0',
            url: 'https://bestmatch.containers.piwik.pro/'
        },
        qa: {
            id: 'd94e6a0d-6a97-4ace-8725-433bd5e698e0',
            url: 'https://bestmatch.containers.piwik.pro/'
        }
    }
};

const DEFAULT_CONFIG: ISiteConfig = {
    prod: { id: 'd94e6a0d-6a97-4ace-8725-433bd5e698e0', url: 'https://bestmatch.containers.piwik.pro/' },
    qa: { id: 'd94e6a0d-6a97-4ace-8725-433bd5e698e0', url: 'https://bestmatch.containers.piwik.pro/' }
};

const hostname: string = window.location.hostname; // e.g., "uwhealthtransplant.donorscreen.ninja"
const sitePrefix: string = hostname.split('.')[0] || '';
const isProd: boolean = hostname.endsWith('.org');

const activeSite: ISiteConfig = CONTAINER_CONFIG[sitePrefix] || DEFAULT_CONFIG;
const targetEnvironment: IEnvironmentDetails = isProd ? activeSite.prod : activeSite.qa;

PiwikPro.initialize(targetEnvironment.id, targetEnvironment.url, {
    nonce: 'nonce-string',
    dataLayerName: 'dataLayer'
});

setPiwikInitialCompliance({
    analytics: { status: 1 }
});

setPiwikCompliance({
    analytics: { status: 1 }
});

// Which workflow and branding the API resolves is driven by the entry domain, and the
// dev server proxies /api (rewriting Host), so every request carries the browser's
// hostname. buildPostHeaders sets the same header on POSTs.
axios.defaults.headers.common['dash-domain'] = window.location.hostname;

// Bootstrap 3.3.7 ships bundled inside Content/nkr.css (loaded via <link> in
// index.html), so it is not imported separately here.
import './styles/global.css';
import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('dash-root');

if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
        // <React.StrictMode>
        <App />
        // </React.StrictMode>
    );
} else {
    console.error('DASH: Could not find root container element (#dash-root)');
}
